import {Row, Col, Form, Space, Divider} from "antd";
import {InputFields} from "components/common";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {fields} from "./config";
import {formatToCurrencyTypeFloor, toNumber} from "helper/common";
import "./Reduce.scss";
import {useAppSelector} from "redux/hooks";
const Reduce = forwardRef((props: any, ref) => {
  const {tongTienDon, detailRecord, tongTienHoanTra} = props;

  const [form] = Form.useForm();
  const [tongTien, setTongTien] = useState(tongTienDon);
  const [giamGia, setGiamGia] = useState(0);
  const [thanhTien, setThanhTien] = useState(0);

  const showHoanLai = useAppSelector(state => state.medicineStore.showHoanLai);
  useEffect(() => {
    setTongTien(tongTienDon);
  }, [tongTienDon]);
  useEffect(() => {
    setThanhTien(detailRecord?.prescriptionDto?.thanhTien);
    setTongTien(detailRecord?.prescriptionDto?.tongTien);
    setGiamGia(detailRecord?.prescriptionDto?.giamGia);
    form.setFieldValue("lyDoGiam", detailRecord?.prescriptionDto?.lyDoGiam);
  }, [detailRecord]);

  useEffect(() => {
    fields.map(e =>
      detailRecord?.prescriptionDto?.status === "DB" ||
      detailRecord?.prescriptionDto?.status === "HL"
        ? (e.disable = true)
        : (e.disable = false)
    );
  }, [detailRecord]);

  useEffect(() => {
    fields.find(e => e.name == "giamGia").onChange = e => {
      setGiamGia(e);
    };
  }, []);

  useEffect(() => {
    setThanhTien(toNumber(tongTien) - toNumber(giamGia));
    form.setFieldValue("tongTien", toNumber(tongTien));
    form.setFieldValue("giamGia", toNumber(giamGia));
  }, [tongTien, giamGia]);
  useEffect(() => {
    console.log(thanhTien);
    form.setFieldValue("thanhTien", toNumber(thanhTien));
  }, [thanhTien]);
  useImperativeHandle(
    ref,
    () => ({
      getDataReduce: () => {
        return form.getFieldsValue();
      },
    }),
    [tongTien, giamGia, thanhTien]
  );

  return (
    <div className="reduce">
      <Row>
        {!showHoanLai && (
          <>
            <Col sm={24} md={8} xl={8}>
              <Form form={form}>
                <Row gutter={[16, 16]}>
                  <InputFields data={fields}></InputFields>
                </Row>
              </Form>
            </Col>
            <Col sm={24} md={16} xl={16}>
              <Space
                split={<Divider type="vertical" />}
                style={{width: "100%", justifyContent: "flex-end"}}
              >
                <div>
                  <span className="label">Tổng tiền:</span>{" "}
                  <span className="value">
                    {formatToCurrencyTypeFloor(tongTien)} VNĐ
                  </span>
                </div>
                <div>
                  <span className="label">Tổng GT giảm:</span>{" "}
                  <span className="value">
                    {formatToCurrencyTypeFloor(giamGia)} VNĐ
                  </span>
                </div>
                <div>
                  <span className="label">Thành tiền:</span>{" "}
                  <span className="value">
                    {formatToCurrencyTypeFloor(thanhTien)} VNĐ
                  </span>
                </div>
              </Space>
            </Col>
          </>
        )}
        {showHoanLai && (
          <Col sm={24} md={24} xl={24}>
            <Space
              split={<Divider type="vertical" />}
              style={{width: "100%", justifyContent: "flex-end"}}
            >
              <div>
                <span className="label">Tổng tiền hoàn trả:</span>{" "}
                <span className="value">
                  {formatToCurrencyTypeFloor(
                    detailRecord?.prescriptionDto?.status == "HL"
                      ? detailRecord?.prescriptionDto?.tongTienHoanTra
                      : tongTienHoanTra
                  )}{" "}
                  VNĐ
                </span>
              </div>
            </Space>
          </Col>
        )}
      </Row>
    </div>
  );
});

export default Reduce;
